/**
 * Cart deals countdown (Theme settings > Cart Deals, snippets/cart-drawer.liquid)
 *
 * Counts down to data-end on its own rather than through custom.js's
 * countdownUpdate(), which reads a single store-wide deadline from the first
 * [data-countdown-end] on the page — a cart deal can end at a different time.
 *
 * The drawer's contents are replaced on every cart change, so the timer lives
 * in connected/disconnectedCallback: each re-rendered copy starts its own and
 * the old one is cleared. At the deadline the whole deals block is removed;
 * the server stops rendering it from then on.
 */
if (!customElements.get('cart-deal-countdown')) {
  customElements.define(
    'cart-deal-countdown',
    class CartDealCountdown extends HTMLElement {
      connectedCallback() {
        this.end = new Date(this.dataset.end).getTime();
        this.time = this.querySelector('[data-role="time"]');
        if (Number.isNaN(this.end) || !this.time) {
          this.hidden = true;
          return;
        }
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      tick() {
        const left = this.end - Date.now();
        if (left <= 0) {
          clearInterval(this.timer);
          (this.closest('.cart-upsell--deals') || this).remove();
          return;
        }

        const pad = (n) => String(n).padStart(2, '0');
        const days = Math.floor(left / 86400000);
        const hours = Math.floor((left % 86400000) / 3600000);
        const minutes = Math.floor((left % 3600000) / 60000);
        const seconds = Math.floor((left % 60000) / 1000);

        const parts = [`${pad(hours)}h`, `${pad(minutes)}m`, `${pad(seconds)}s`];
        if (days > 0) parts.unshift(`${days}d`);
        this.time.textContent = parts.join(' ');
      }
    }
  );
}
